import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=22f59434&scoped=true&"
import script from "./svgIcon.ts?vue&type=script&lang=ts&"
export * from "./svgIcon.ts?vue&type=script&lang=ts&"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=22f59434&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f59434",
  null
  
)

export default component.exports